module.exports = __webpack_public_path__ + "img/video_img.443c6f37.svg";